/* ============================================================
   Capa PW del cart drawer: progreso de ahorro + upsell.

   Por que va inyectado y no dentro de snippets/cart-drawer.liquid:
   ese archivo son 30 KB de Shopify. Tocarlo obliga a reescribirlo
   entero en cada cambio y a rehacerlo en cada actualizacion del tema.
   Inyectando, la capa PW es independiente y no puede romper el carrito.

   Y una correccion de fondo: la tienda YA regala el envio en todos los
   pedidos, asi que una barra de "te faltan X para envio gratis" seria
   falsa. La barra mide el progreso hacia los descuentos que existen de
   verdad: BUNDLE2 (10%) y BUNDLE3 (25%).
   ============================================================ */
if (!window.pwCarritoCargado) {
  window.pwCarritoCargado = true;

  var pwDrawer = null;
  var pwObs = null;
  var pwPendiente = false;

  function pwCfg() {
    var el = document.querySelector('[data-pw-cart-cfg]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function pwDinero(c) { return '$' + (c / 100).toFixed(2); }

  function pwPintar(cart, cfg) {
    var pie = document.querySelector('#CartDrawer .drawer__footer');
    if (!pie) return;

    var caja = pie.querySelector('.pw-cart');
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'pw-cart pw-glass pw-glass--suave';
      pie.insertBefore(caja, pie.firstChild);
    }

    /* Solo cuentan las unidades del producto del bundle. */
    var uds = 0;
    (cart.items || []).forEach(function (i) {
      if (!cfg.variante || String(i.variant_id) === String(cfg.variante)) uds += i.quantity;
    });

    var niveles = cfg.niveles || [];
    var siguiente = null;
    for (var n = 0; n < niveles.length; n++) {
      if (uds < niveles[n].qty) { siguiente = niveles[n]; break; }
    }
    var tope = niveles.length ? niveles[niveles.length - 1].qty : 0;
    var pct = tope ? Math.min(100, Math.round((uds / tope) * 100)) : 0;

    var msg;
    if (!uds) {
      msg = cfg.txt_vacio;
    } else if (siguiente) {
      var faltan = siguiente.qty - uds;
      msg = cfg.txt_faltan
        .replace('[n]', faltan)
        .replace('[pct]', siguiente.pct + '%')
        .replace('[pack]', faltan === 1 ? cfg.txt_pack : cfg.txt_packs);
    } else {
      msg = cfg.txt_maximo.replace('[pct]', niveles[niveles.length - 1].pct + '%');
    }

    var hitos = niveles.map(function (n) {
      return '<span class="pw-cart__hito' + (uds >= n.qty ? ' pw-cart__hito--hecho' : '') + '">' +
        n.qty + ' · −' + n.pct + '%</span>';
    }).join('');

    var up = '';
    if (siguiente && cfg.variante) {
      up = '<div class="pw-cart__up">' +
        (cfg.imagen ? '<img src="' + cfg.imagen + '" alt="" width="46" height="46" loading="lazy">' : '') +
        '<div class="pw-cart__up-txt"><strong>' + cfg.titulo + '</strong>' + pwDinero(cfg.precio) + '</div>' +
        '<button type="button" data-pw-up>' + cfg.txt_boton + '</button></div>';
    }

    caja.innerHTML =
      '<p class="pw-cart__linea"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' + cfg.txt_envio + '</p>' +
      '<p class="pw-cart__msg">' + msg + '</p>' +
      '<div class="pw-cart__riel"><span class="pw-cart__barra" style="width:' + pct + '%"></span></div>' +
      (hitos ? '<div class="pw-cart__hitos">' + hitos + '</div>' : '') +
      up;

    var boton = caja.querySelector('[data-pw-up]');
    if (boton) {
      boton.addEventListener('click', function () {
        boton.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: cfg.variante, quantity: 1 }] })
        }).then(function () {
          /* Se recarga la pagina para que los totales y los descuentos
             los siga calculando Shopify, no este script. */
          location.reload();
        }).catch(function () { boton.disabled = false; });
      });
    }
  }

  /* pwPintar escribe DENTRO del drawer, que es justo lo que observa el
     MutationObserver. Sin desconectarlo antes, cada repintado dispararia
     otro repintado: bucle infinito. Se apaga, se pinta y se reengancha. */
  function pwPintarSeguro(cart, cfg) {
    if (pwObs) pwObs.disconnect();
    try { pwPintar(cart, cfg); } finally {
      if (pwObs && pwDrawer) pwObs.observe(pwDrawer, { childList: true, subtree: true });
    }
  }

  function pwActualizar() {
    var cfg = pwCfg();
    if (!cfg || pwPendiente) return;
    pwPendiente = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { pwPendiente = false; pwPintarSeguro(c, cfg); })
      .catch(function () { pwPendiente = false; });
  }

  function pwCarritoInit() {
    pwDrawer = document.querySelector('#CartDrawer');
    if (!pwDrawer || pwDrawer.dataset.pwListo) return;
    pwDrawer.dataset.pwListo = '1';
    /* Dawn reemplaza el HTML del drawer en cada cambio del carrito, asi
       que en vez de adivinar sus eventos se observa el propio nodo. */
    pwObs = new MutationObserver(function () { pwActualizar(); });
    pwObs.observe(pwDrawer, { childList: true, subtree: true });
    pwActualizar();
  }

  pwCarritoInit();
  document.addEventListener('DOMContentLoaded', pwCarritoInit);
}
